import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import clsx from 'clsx';
import $ from 'jquery';

import APFormGroup from 'components/FormFields/APFormGroup';
import { checkInputForCardData } from 'utils/payments';
import { parseFsMessage } from '../utils/messages';

window.jQuery = $;

const AchPay = ({ authKey, chargeAmount, identifier, setErrorMessage, setResponse, setDisableSubmit }) => {
  // Manage psudo focus state from iframe elements.
  const [isAccountNumFocused, setAccountNumFocused] = useState(false);
  const [isVerificationFocused, setVerificationFocused] = useState(false);
  const [isRoutingFocused, setRoutingFocused] = useState(false);
  const [isAccountTypeFocused, setAccountTypeFocused] = useState(false);

  // Manage error states from iframe elements.
  const [accountNumError, setAccountNumError] = useState('');
  const [verificationError, setVerificationError] = useState('');
  const [routingError, setRoutingError] = useState('');
  const [accountTypeError, setAccountTypeError] = useState('');

  // emitted function names from hosted payments messages.
  /* eslint-disable */
  const accountNumberFocusIn = () => setAccountNumFocused(true);
  const accountNumberFocusOut = () => setAccountNumFocused(false);

  const routingNumberFocusIn = () => setRoutingFocused(true);
  const routingNumberFocusOut = () => setRoutingFocused(false);

  const accountNumberReEntryFocusIn = () => setVerificationFocused(true);
  const accountNumberReEntryFocusOut = () => setVerificationFocused(false);

  const accountTypeFocusIn = () => setAccountTypeFocused(true);
  const accountTypeFocusOut = () => setAccountTypeFocused(false);

  const accountNumberValidation = (value) => {
    if (value === 'false') {
      setAccountNumError('The Account Number field is invalid.');
    } else {
      setAccountNumError('');
    }
  }

  const accountNumberReEntryValidation = (value) => {
    if (value === 'false') {
      setVerificationError('The Account number validation field is invalid.');
    } else {
      setVerificationError('');
    }
  }

  const routingNumberValue = (value) => {
    if (value === 'false') {
      setRoutingError('The Routing Number is invalid.');
    } else {
      setRoutingError('');
    }
  }

  const accountTypeValue = (value) => {
    if (type === 'false') {
      setAccountTypeError('The account type is invalid.');
    } else {
      setAccountTypeError('');
    }
  }
  /* eslint-enable */
  // end emitted function names from hosted payments messages.

  const handleFsMessage = (e) => {
    const [functionName, arg] = parseFsMessage(e);
    try {
      // eslint-disable-next-line no-eval
      eval(functionName)(arg);
    } catch (err) {
      // Do Nothing
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleFsMessage);
    return () => {
      window.removeEventListener('message', handleFsMessage);
    };
  }, []);

  useEffect(() => {
    if (accountNumError || verificationError || routingError || accountTypeError) {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
  }, [accountNumError, verificationError, routingError, accountTypeError]);

  function handleOnLoad() {

    let invoiceNum = (identifier.length > 20) ? identifier.substring(0,20) : identifier;
    if (checkInputForCardData(invoiceNum)) {
      const filteredInvoiceNum = ((invoiceNum.length > 14) ? invoiceNum.substring(0,14) : invoiceNum);
      invoiceNum = `ap_${filteredInvoiceNum}_cc`;
    }

    const fullsteamHostedPaymentsParameters = {
      authenticationKey: authKey,
      operationType: 'Payment',
      formId: 'payment-form',
      paymentSourceType: 'ACH',
      achAuthorizationType: 'WEB',
      nameOnAccountField: 'NameOnAccount',
      firstNameField: 'FirstName',
      middleNameField: 'MiddleName',
      lastNameField: 'LastName',
      address1Field: 'Address1',
      cityField: 'City',
      stateField: 'State',
      zipField: 'Zip',
      countryField: 'Country',
      phoneField: 'Phone',
      emailField: 'Email',
      paymentAmount: chargeAmount,
      invoiceNumber: invoiceNum,
      customerId: invoiceNum,
      includeTokenInResponse: true,
    };
    function handleHostedPaymentsError(errorMessage) {
      setErrorMessage(errorMessage);
      setDisableSubmit(false);
    }

    function handleGatewayError(gatewayResponse) {
      setResponse(gatewayResponse);
    }

    $(document).ready(() => {
      // Add Callbacks
      fullsteamHostedPaymentsParameters.gatewayErrorCallback = handleGatewayError;
      fullsteamHostedPaymentsParameters.hostedPaymentsSimpleError = handleHostedPaymentsError;

      // eslint-disable-next-line no-undef
      const setupSuccessful = setupFullsteamHostedPayments(fullsteamHostedPaymentsParameters);
      if (!setupSuccessful) {
        $('#submitButton').toggle(false);
      }
    });
  }

  const handleScriptInject = ({ scriptTags }) => {
    if (scriptTags) {
      const scriptTag = scriptTags[0];
      scriptTag.onload = handleOnLoad;
    }
  };

  return (
    <>
      <Helmet
        script={[
          { src: `${process.env.REACT_APP_FULLSTEAM_JS_URL}` },
          { src: 'https://code.jquery.com/ui/1.12.1/jquery-ui.min.js',
            integrity: 'sha256-VazP97ZCwtekAsvgPBSUwPFKdrwD3unUfSGVYrahUqU=',
            crossOrigin: 'anonymous' },
          { src: 'https://ajax.aspnetcdn.com/ajax/jquery.validate/1.17.0/jquery.validate.min.js',
            crossOrigin: 'anonymous',
            integrity: 'sha384-rZfj/ogBloos6wzLGpPkkOr/gpkBNLZ6b6yLy4o+ok+t/SAKlL5mvXLr0OXNi1Hp' },
          { src:
            'https://ajax.aspnetcdn.com/ajax/jquery.validation.unobtrusive/3.2.9/jquery.validate.unobtrusive.min.js',
          crossOrigin: 'anonymous',
          integrity: 'sha384-ifv0TYDWxBHzvAk2Z0n8R434FL1Rlv/Av18DXE43N/1rvHyOG4izKst0f2iSLdds',
          },

        ]}
        onChangeClientState={(newState, addedTags) => {
          // const selected = localStorage.getItem('selected');
          // if (selected.includes('ach')) return;
          // localStorage.setItem('selected', `${selected},ach`);
          handleScriptInject(addedTags);
        }}
      />
      <APFormGroup
        gridGap={1}
        verticalGap={0}
      >
        <div className="form-item form-item--iframe">
          <label className="control-label">Account Number</label>
          <label id="card-number-type"
            className="control-label pull-right"
          />
          <div className="form-item__frame">
            <div className={clsx('iframe-input', isAccountNumFocused && 'focus', accountNumError && 'error')}
              id="fullsteam-hosted-account-number-div"
            />
          </div>
          <div
            className="form-item__error"
            id="fullsteam-hosted-account-number-error"
          >
            {accountNumError}
          </div>
        </div>
        <div className="form-item form-item--iframe">
          <label className="control-label">Account Number Verification</label>
          <div className="form-item__frame">
            <div className={clsx('iframe-input', isVerificationFocused && 'focus', verificationError && 'error')}
              id="fullsteam-hosted-account-number-reentry-div"
            />
          </div>
          <div
            className="form-item__error"
            id="fullsteam-hosted-account-number-reentry-error"
          >
            {verificationError}
          </div>
        </div>
      </APFormGroup>
      <APFormGroup
        gridGap={1}
        verticalGap={0}
      >
        <div className="form-item form-item--iframe">
          <label className="control-label">Routing Number</label>
          <div className="form-item__frame">
            <div className={clsx('iframe-input', isRoutingFocused && 'focus', routingError && 'error')}
              id="fullsteam-hosted-routing-number-div"
            />
          </div>
          <div
            className="form-item__error"
            id="fullsteam-hosted-routing-number-error"
          >
            {routingError}
          </div>
        </div>
        <div className="form-item form-item--iframe">
          <label className="control-label">Account Type</label>
          <div className="form-item__frame">
            <div className={clsx('iframe-input', isAccountTypeFocused && 'focus', accountTypeError && 'error')}
              id="fullsteam-hosted-account-type-div"
            />
          </div>
          <div
            className="form-item__error"
            id="fullsteam-hosted-account-type-error"
          >
            {accountTypeError}
          </div>
        </div>
      </APFormGroup>
    </>
  );
};

export default AchPay;
